/**
 * Trạng thái đăng nhập hệ thống KBNN - DVC
 * hkcuong 25.12.2025
 */
export default {
  Logout: 0, // Chưa đăng nhập
  Login: 1, // Đã đăng nhập
};
